import { BasicTooltip, Icon, LoaderButton, SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
export default function SendStatementsModal(props) {
  const classes = useStyles();
  const _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$isIconTrigger = props.isIconTrigger,
    isIconTrigger = _props$isIconTrigger === void 0 ? false : _props$isIconTrigger,
    _props$isTenantView = props.isTenantView,
    isTenantView = _props$isTenantView === void 0 ? false : _props$isTenantView,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? undefined : _props$trigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: "action",
    'custom-attribute': '424-SendStatementsModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "mail-send"
  }), isTenantView ? t('general.send') : t('general.send_all'));
  const iconTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('residencies_page.send_statements'),
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '425-SendStatementsModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "mail-send"
  })));
  const getTrigger = () => {
    if (trigger) return trigger;
    if (isIconTrigger) return iconTrigger;
    return defaultTrigger;
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: getTrigger(),
    title: t('residencies_page.send_statements'),
    rightButton: /*#__PURE__*/React.createElement(LoaderButton, {
      loadingText: "Sending...",
      buttonText: "Send statements",
      successText: "Sent successfully",
      errorText: "Sending failed",
      status: "success"
    }),
    noPadding: true
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('residencies_page.allocations_not_complete')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('residencies_page.allocations_not_complete_desc'))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    size: "small",
    'custom-attribute': '426-SendStatementsModal'
  }, t('residencies_page.open_allocation_tables')), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('residencies_page.select_channels'))), /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxes
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: t('residencies_page.send_in_app_statements')
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: t('residencies_page.send_statement_pdf')
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: t('residencies_page.send_paper_mails')
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: t('residencies_page.incomplete_statements')
  })))));
}
SendStatementsModal.propTypes = {
  disabled: PropTypes.bool,
  isIconTrigger: PropTypes.bool,
  isTenantView: PropTypes.bool,
  trigger: PropTypes.node
};